import React, { useEffect } from 'react';
import './ConfigWebPagePatients.scss';
import { ScrollView, Tabs, Toolbar } from 'devextreme-react';
import { Item } from 'devextreme-react/toolbar';
import { useAppSelector } from '../../contexts/hooks';
import { ConfigGeneral } from './components/ConfigGeneral';
import ConfigUsuarios from './components/ConfigUsuarios';

export default () => {
  const [TabsConfigurations, setTabsConfigurations] = React.useState<any[]>([]);
  const Prm_PagWebRes_Config_General = useAppSelector((x) => x.userInfo.Permissions?.Prm_PagWebRes_Config_General);
  const Prm_PagWebRes_Usuarios_R = useAppSelector((x) => x.userInfo.Permissions?.Prm_PagWebRes_Usuarios_R);
  const [currentSelectedTab, setCurrentSelectedTab] = React.useState<number>(0);  

  useEffect(() => {
    if (Prm_PagWebRes_Usuarios_R) {
      //Agregar a GroupsConfigurations
      setTabsConfigurations((prev) => [...prev, { Value: 0, Text: 'Usuarios' }]);
    }
    if (Prm_PagWebRes_Config_General) {
      //Agregar a GroupsConfigurations
      setTabsConfigurations((prev) => [...prev, { Value: 1, Text: 'Configuración General' }]);
    }
  }, []);

  const handleClicTab = (e: any) => {
    const selectedTab = e.itemData.Value;
    setCurrentSelectedTab(selectedTab);
  };

  const handleRenderTitle = (item: any) => {
    return <span className='tab-title'>{item.Text}</span>;
  };

  return (
    <div className='view-wrapper view-wrapper-task-list'>
      <ScrollView className='view-wrapper-scroll' height={'100%'}>
        <Toolbar className='toolbar-common'>
          <Item location='before'>
            <span className='toolbar-header'>Conf. Página web resultados (Pac - Centros)</span>
          </Item>
          <Item location='before' widget='dxTabs'>
            <Tabs defaultSelectedIndex={0} dataSource={TabsConfigurations} itemRender={handleRenderTitle} width={'auto'} onItemClick={handleClicTab} selectedIndex={currentSelectedTab} scrollByContent showNavButtons={false}></Tabs>
          </Item>
        </Toolbar>
        <div className='formStyle'>{currentSelectedTab === 0 && Prm_PagWebRes_Usuarios_R && <ConfigUsuarios />}</div>
        <div className='formStyle'>{currentSelectedTab === 1 && Prm_PagWebRes_Config_General && <ConfigGeneral />}</div>
      </ScrollView>
    </div>
  );
};
